<template id="productList">
<section id="product">

<bulkModal :common_res="common_res" :res="res" :id="'bulkbox'"></bulkModal>
<bulkListModal :common_res="common_res" :res="res" :id="'bulklistbox'"></bulkListModal>
<processingOrderListModal :common_res="common_res" :res="res" :id="'porderlistbox'"></processingOrderListModal>

  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <div class="twoColumn">
        
          <div :class="'leftCol leftcolumn'+(showSidebar?' prosidebar':'')" style="_height: 1335px;" v-on:dragover="$event.preventDefault()" v-on:drop="$event.preventDefault()">
            <div class="productID">
              <label>{{res.productid}} <span style="color:yellow">&nbsp;&nbsp;({{res.press_enter}})</span></label>
              <input @input="$emit('resetSearch', $event)" v-on:blur="searchID($event.target.value)" v-on:keyup.enter="searchID($event.target.value)" v-model="product_id" type="number" class="inputFeild">
            </div>
            <div class="keyword">
              <label>{{res.keyword}}</label>
              <input @input="$emit('resetSearch', $event)" v-on:blur="search()" v-on:keyup.enter="search()" v-model="(product_name)" type="text" class="inputFeild">
            </div>
            <div class="selOuter">
              <label>{{res.brand}}</label>
              <dl id="sample" class="dropdownSel">
                <dt><a href="javascript:void(0)" v-on:click="showBrand = !showBrand; showCat = false"><span v-if="brand != null"><img width="67px" class="flag" :src="brand.logo" alt=""> {{brand.cat_name}}</span><span v-else>&nbsp;</span></a></dt>
                <dd>
                  <ul abcstyle="display:block" :style="showBrand?'display:block':'display:none'">
                    <li v-if="brand != null"><a v-on:click="selectBrand()" href="javascript:void(0)">&nbsp;</a></li>
                    <li v-for="(brand) in brands" v-bind:key="brand"><a v-on:click="selectBrand(brand)" href="javascript:void(0)"><img width="67px" class="flag" :src="brand.logo" alt=""> {{brand.cat_name}}</a></li>
                  </ul>
                </dd>
              </dl>
            </div>
              <label>{{res.category}}</label>
            <dl id="sample" class="dropdownSelnew">
              <dt><a href="javascript:void(0)" v-on:click="showCat = !showCat; showBrand = false"><span v-if="cat != null"><img width="67px" class="flag" :src="cat.logo" alt=""> {{cat.cat_name}}</span><span v-else>&nbsp;</span></a></dt>
              <dd>
                <ul :style="showCat?'display:block':'display:none'">
                  <li v-if="cat != null"><a v-on:click="selectCat()" href="javascript:void(0)">&nbsp;</a></li>
                  <li v-if="cat.logo != ''" v-for="(cat) in cats" v-bind:key="cat"><a v-on:click="selectCat(cat)" href="javascript:void(0)"><img width="67px" class="flag" :src="cat.logo" alt=""> {{cat.cat_name}}</a></li>
                  <!--li><a href="javascript:void(0)"><img class="flag" src="@/images/condom.png" alt=""> Condom01<span class="value">BR</span></a></li>
                  <li><a href="javascript:void(0)"><img class="flag" src="@/images/condom.png" alt=""> Condom02<span class="value">FR</span></a></li-->
                </ul>
              </dd>
            </dl>
            <div class="tags">
              <a v-on:click="toggleFilter('new')" href="javascript:void(0)" :class="isFilter('new')?'redtag':''">{{res.new}}</a>
              <a v-on:click="toggleFilter('sales')" href="javascript:void(0)" :class="isFilter('sales')?'redtag':''">{{res.sales}}</a>
              <a v-on:click="toggleFilter('best')" href="javascript:void(0)" :class="isFilter('best')?'redtag':''">{{res.best}}</a> </div>
            <div class="tags tegForBtn">
              <label>{{res.orderby}}</label>
              <a href="javascript:void(0)" v-on:click="tosort('new')" :class="sort=='new'?'redtag':''">{{res.new}}</a>
              <a href="javascript:void(0)" v-on:click="tosort()" :class="sort==null?'redtag':''">{{res.default}}</a>
              <a href="javascript:void(0)" v-on:click="tosort('gp')" :class="sort=='gp'?'redtag':''">{{res.gpp}}</a>
              <a href="javascript:void(0)" v-on:click="tosort('gps')" :class="sort=='gps'?'redtag':''">{{res.gps}}</a>
            </div>
            <div class="enterdata" data-toggle="modal" data-target="#myModal"><a :class="bulking?'active':''" v-on:dragleave="bulking=false" v-on:dragover="bulking=true;$event.preventDefault()" v-on:drop="dropFileEvent($event)" v-on:click="openBulk" href="javascript:void(0)">{{res.enterbulk}}</a></div>
			<!-- Button trigger modal -->

            <!--div class="placeholder" data-toggle="modal" data-target="#myModal01"><a href="javascript:void(0)">{{res.place_order}}</a></div-->
            <!-- second modal-->
          </div>
      <!-- <div class="searchicon visible-xs"><img src="@/images/searchicon.png" alt="image"/> </div> -->
        <div v-on:click="showSidebar = !showSidebar" class="searchicon visible-xs"><i class="fa fa-search"></i></div>
          <div class="rightCol rightpad">
            <div class="b2b_shelfs_bar">
              <div class="container">
                <div class="b2b_shelfs_bar_left filters">
                  <a :class="isFilter('new')?'redtag':''" v-on:click="toggleFilter('new')" href="javascript:void(0)"> <img src="@/images/staricon.png" alt="image"> {{res.new}} </a>
                  <a :class="isFilter('sales')?'redtag':''" v-on:click="toggleFilter('sales')" href="javascript:void(0)"><img src="@/images/salesicon.png" alt="image"> {{res.sales}}</a>
                  <a :class="isFilter('best')?'redtag':''" v-on:click="toggleFilter('best')" href="javascript:void(0)"><img src="@/images/sellingicon.png" alt="image"> {{res.best}}</a>
                </div>
                <!--div v-if="common_res.switch_view != null" class="b2b_shelfs_bar_right"-->
                <div v-if="isPog">
                  <a href="../pog/index.html" class="btn submitButton switchViewButton"><i class="fa fa-th"></i> {{ common_res.switch_view  }}</a>
                </div>
              </div>
            </div>
            <orderProduct :fmt="product.ratedp" :skey="product.pdetails.product_id+'@'+searchCount" v-for="(product, pidx) in products" :common_res="common_res" :res="res" :details="product" :stock="getProductStock(product)" :iqty="getCartQty(product)" :idx="pidx" v-bind:key="product.pdetails.product_id+'@'+searchCount"/>
		 <div class="pmGpage sections text-center coursePaging"> 
			<div class="Paginaton" v-if="pagination != null && pagination.pages != null && pagination.pages.length > 0">
				<ul class="pagination blogPages">
					<li class="select prevExt"><a href="javascript:void(0)" v-on:click="goPageNo(pageno-1)"><i class="fa fa-caret-left"></i> Prev</a></li>
					<li :class="(pageno == idx)?'active':''" v-for="(page, pageno) in pagination.pages" v-bind:key="page"><a href="javascript:void(0)" v-on:click="goPage(page.url)">{{pageno + 1}}</a></li>
					<li class="select nextExt"><a href="javascript:void(0)" v-on:click="goPageNo(pageno+1)">Next <i class="fa fa-caret-right"></i></a></li>
				</ul>
			</div>
		</div>
            <!----------->
            <div class="redBarOuter">
              <div class="redbar">
                <div class="icon"><img alt="#" src="@/images/notification.png"></div>
                <div class="warning-text">
                  <p v-html="res.desp1"></p>
                  <p v-html="res.desp2"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'
import orderProduct from './OrderProduct.vue'
import bulkModal from './BulkModal.vue'
import bulkListModal from './BulkListModal.vue'
import processingOrderListModal from './ProcessingOrderListModal.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

// shelf_mode = '01:10:11'
// if null, => '01' (only ProductList)
// first bit => ProductList
// second bit => pog
export default {
  name: 'productList',
  props:['name', 'clients', 'firstamts', 'countries', 'common_res', 'res', 'order_processing', 'pdiscounts', 'shelf_mode'],
  data () {
    return {
      alertlist:{"nostock":[], "ltstock":[]},
      bulking:false,
      processing:false,
      locale:null,
      searchCount:0,
      allLoaded:false,
      searching:false,
      brands:[],
      showBrand:false,
      showSidebar:false,
      brand:null,
      cat:null,
      showCat:false,
      cats:[],
      products:[],
      product_name:null,
      product_id:null,
      pageno:-1,
      pagination:{},
      cartP:null,
      filters:[],
      sort:null,
      tproducts:[{"productid":"111", "unitdiscount":{"qty":12, "discount":"-10", "type":"per"}}, {"productid":"111"},{"productid":"123", "history":[]}, {"productid":"234", "history":[], "casediscount":{"box":"144", "discount":"-20", "type":"cst"}}, {"productid":"234", "history":[], "unitdiscount":{"qty":12, "discount":"-10", "type":"per"}}, {"productid":"234", "history":[], "casediscount":{"box":"144", "discount":"-10", "type":"per"}, "unitdiscount":{"qty":"6", "discount":"-1", "type":"unit"}}],
      token:null,
      submitted:false,
      searchable:true,
      error:{}
    }
  },
  components: {
    orderProduct,
    bulkModal,
    bulkListModal,
    processingOrderListModal
  },
  created: function() {
    var self = this;
    this.$root.$on('added', data => {
      if (!self.processing) {
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.added, 'button':this.common_res.message.close, 'icon':'fa-check', 'timeout':2000});
      }
    });
    this.$root.$on('bulk', function(evt) {
      console.log('bulk', evt);
      self.processing = evt.processing;
    });
    this.$on('resetSearch', function(evt) {
      self.searchable = true;
      //console.log('resetSearch', evt.target);
    });
    this.locale = utils.getLocale();
    //Vue.http.get(utils.getServerPath()+'/product/search.is?'+this.locale).then(response => {
    //  self.products = response.body.productlist;
    //});
    this.$root.$on('chk_buy', data => {
      // disable it first, waiting for the GUI @20200720
      if (1==2) {
        this.$root.$emit(data.action, data);
        return;
      }
      var cart = utils.getCartStorage();
      if (cart.length > 0 || this.order_processing == null || this.order_processing.length == 0) {
        if (data.action != null) {
          this.$root.$emit(data.action, data);
        }
        return;
      }
      var self = this;
      var msg = "";
      for (var i=0;i<this.order_processing.length;i++) {
        msg = msg + "- "+this.order_processing[i].invcode+"\n";
      }
      self.$root.$emit('confirm_processing', {
        list:self.order_processing,
        nextfunc:function(icode) {
          //var icode = prompt("Add to any processing orders, please enter one of invoice number below. Or press \"cancel\" to create a new order.\n"+msg.substring(0, msg.length-1), "[invoice number]");
          if (icode != null && icode.trim() != '') {
            for (var i=0;i<self.order_processing.length;i++) {
              if (icode == self.order_processing[i].invcode) {
                var aqty = {};
                Vue.http.get(utils.getServerPath()+"/order/orderDetails.is?invid="+self.order_processing[i].invid).then(response => {
                  var porder = response.body.processing;
                  utils.backupCart({"bill_no":icode,"bchfk":porder[0].bchfk});
                  for (var j=0;j<porder.length;j++) {
                    if (porder[j].isproduct == '1') {
                      var pid = porder[j].productfk;
                      var qty = porder[j].quantity;
                      if (porder[j].discounts != "") {
                        var d = JSON.parse(porder[j].discounts);
                        for (var k=0;k<d.length;k++) {
                          if (d[k].prefix == 'FG' && d[k].wfreen > 0) {
                            var m = (qty % (parseInt(d[k].wbuym) + parseInt(d[k].wfreen)));
                            qty = ((qty-m) / (parseInt(d[k].wbuym) + parseInt(d[k].wfreen))) * d[k].wbuym + m;
                          }
                        }
                      }
                      aqty[pid] = qty;
                      self.$root.$emit('buy', {details:{'pdetails':{'product_id':pid}}, oqty:qty})
                    }
                  }
                  utils.saveStorage('cart.aqty', aqty);
                  if (data.action != null) {
                    self.$root.$emit(data.action, data);
                  }
                });
              }
            }
          } else {
            if (data.action != null) {
              self.$root.$emit(data.action, data);
            }
          }
        }
      });
    });
    this.$root.$on('buy', data => {
      self.cartP = null;
    });
  },
  methods: {
    getProductStock:function(product) {
      return product.stock + utils.getAQty(product.pdetails.product_id);
    },
    dropFileEvent:function(evt) {
      evt.preventDefault();
      this.bulking = false;
      this.$root.$emit('dropbulkfile', {"files":evt.dataTransfer.files});
    },
    openBulk:function() {
      this.$root.$emit('modal.bulkbox', {'mode':'show'});
    },
    getCartQty:function(p) {
      if (this.cartP == null) {
        this.cartP = utils.getCartStorage();
      }
      if (this.cartP == null) return 0;
      for (var i=0;i<this.cartP.length;i++) {
        if (this.cartP[i].product_id == p.pdetails.product_id) {
          this.$root.$emit('setQty.'+p.pdetails.product_id, {oqty:this.cartP[i].oqty});
          console.log(this.cartP[i], p.pdetails);
          return this.cartP[i].oqty;
        }
      }
      this.$root.$emit('setQty.'+p.pdetails.product_id, {oqty:0});
      return 0;
    },
    subVals(line, vals) {
      return utils.subVals(line, vals);
    },
    confirmAll:function() {
      for (var i=this.alertlist.ltstock.length-1;i>=0;i--) {
        var p = this.alertlist.ltstock[i];
        if (p.confirmed == null) {
          p.to_oqty = p.ad_oqty;
          p.confirmed = true;
        }
        if (p.wbuym != null && p.wbuym != 0) {
          p.to_oqty = parseInt(p.to_oqty / (p.wbuym + p.wfreen)) * p.wbuym;
          if (p.to_oqty == 0) {
            p.to_oqty = p.stock;
          }
        }
      }
      this.alertlist.nostock = [];
      console.log('confirmall', this.alertlist);
      if (this.alertlist.ltstock != null) {
        for (var i=0;i<this.alertlist.ltstock.length;i++) {
          var product = this.alertlist.ltstock[i];
          if (product.idx >= 0) {
            this.$root.$emit('qty', {idx:product.idx, oqty:product.to_oqty});
          } else {
            this.$root.$emit('buy', {details:product, oqty:product.to_oqty});
          }
        }
        this.bulk = null;
        $('#myModal01').modal('hide');
      }
      this.alertlist.ltstock = [];
      this.cartP = null;
      this.$forceUpdate();
    },
    confirmProduct:function(product, qty) {
      product.to_oqty = qty;
      product.confirmed = true;
      this.$forceUpdate();
    },
    removeProduct:function(product, list) {
      if (list != null) {
        for (var i=0;i<list.length;i++) {
          if (list[i].pdetails.product_id == product.pdetails.product_id) {
            list.splice(i, 1);
            break;
          }
        }
      }
      if ((this.alertlist.nostock == null || this.alertlist.nostock.length == 0) && (this.alertlist.ltstock == null || this.alertlist.ltstock.length == 0)) {
        $('#myModal01').modal('hide');
      }
    },
    processBulk:function(product, qtys, key) {
      var self = this;
      var qty = qtys[product.pdetails[key]];
      var tmpPs = utils.getCartStorage();
      if (tmpPs != null) {
        for (var i=0;i<tmpPs.length;i++) {
          var id = tmpPs[i].product_id;
          if (id == product.pdetails.product_id) {
            //qty = qty + parseInt(tmpPs[i].oqty);
            product.idx = i;
            break;
          }
        }
      }
      product.to_oqty = qty;
      product.stock = parseInt(product.stock);
      if ((product.wbuym != null && product.wbuym != '0')) {
        product.wbuym = parseInt(product.wbuym);
        product.wfreen = parseInt(product.wfreen);
      } else {
        product.wbuym = 0;
      }
      if (product.stock <= 0) {
        self.alertlist.nostock.push(product);
      } else if (product.stock < qty) {
        product.ad_oqty = product.stock;
        if ((product.wbuym != null && product.wbuym != 0 && (((product.wbuym + product.wfreen) > product.stock) || (qty % (product.wbuym + product.wfreen)) != 0))) {
          product.ad_oqty = Math.floor(product.stock / (parseInt(product.wbuym) + parseInt(product.wfreen))) * (parseInt(product.wbuym) + parseInt(product.wfreen));
        }
        if (product.ad_oqty == 0) {
          product.ad_oqty = product.stock;
        }
        self.alertlist.ltstock.push(product);
      } else if ((product.wbuym != null && product.wbuym != 0 && (((product.wbuym + product.wfreen) > product.stock) || (qty % (product.wbuym + product.wfreen)) != 0))) {
        self.alertlist.ltstock.push(product);
        product.ad_oqty = Math.ceil(product.to_oqty / (parseInt(product.wbuym) + parseInt(product.wfreen))) * (parseInt(product.wbuym) + parseInt(product.wfreen));
      } else {
        if (product.wbuym != 0) {
          //qty = Math.ceil(qty / (parseInt(product.wbuym) + parseInt(product.wfreen))) * (parseInt(product.wbuym) + parseInt(product.wfreen));
          qty = parseInt(qty / (product.wbuym + product.wfreen)) * product.wbuym;
        }
        if (product.idx >= 0) {
          this.$root.$emit('qty', {idx:product.idx, oqty:qty});
        } else {
          this.$root.$emit('buy', {details:product, oqty:qty});
        }
      }
      this.cartP = null;
      this.$forceUpdate();
    },
    bulkAdd:function() {
      var codeidx = 2;
      var pididx = 3;
      var qtyidx = 1;
      //var bulkline = /(?<qty>[0-9]*)[\s]*x[\s\S]* (?:[\s]*\[(?<code>[0-9,]*)\])?(?:\{(?<id>[0-9]*)\})?/;
      var bulkline = /([0-9]*)[\s]*x[\s\S]* (?:[\s]*\[([0-9,]*)\])?(?:\{([0-9]*)\})?/;
      if (this.bulk != null) {
        this.bulk = this.bulk.replace(/\] \{/g, "]{");
        var lines = this.bulk.split('\n');
        var pids = "";
        var qtys = {};
        var eqtys = {};
        var eans = [];
        var ids = [];
        var tmpCur = utils.getCartStorage();
        for(var i = 0;i < lines.length;i++) {
          var info = bulkline.exec(lines[i]);
          //var info = lines[i].split(',');
          if (info.length == 2) {
            info.splice(0, 0, info[codeidx]);
          }
          if (isNaN(info[qtyidx])) {
            continue;
          }
          pids = pids + '&product_id='+info[pididx];
          var eint = parseInt(info[codeidx]);
          if (isNaN(eint) || eint < 1000000) {
            eint = parseInt(info[pididx]);
            if (!isNaN(eint) && eint > 10000000) {
              eans.push(info[pididx]);
              eqtys[info[pididx]] = parseInt(info[qtyidx]);
            } else {
              eans.push('');
              eqtys[info[pididx]] = parseInt(info[qtyidx]);
            }
          } else {
            eans.push(info[codeidx]);
            eqtys[info[codeidx]] = parseInt(info[qtyidx]);
          }
          ids.push(info[pididx]);
          qtys[info[pididx]] = parseInt(info[qtyidx]);
          //code here using lines[i] which will give you each line
        }
        var self = this;
        Vue.http.get(utils.getServerPath()+'/product/search.is?'+pids).then(response => {
          var productlist = response.body.productlist;
          self.alertlist = {"nostock":[], "ltstock":[], "adstock":[]};
          if (productlist != null && productlist.length > 0) {
            for (var i=0;i<productlist.length;i++) {
              self.processBulk(productlist[i], qtys, 'product_id');
              var idx = eans.indexOf(productlist[i].pdetails.product_code);
              if (idx >= 0) {
                eans.splice(idx, 1);
                ids.splice(idx, 1);
              } else {
                idx = ids.indexOf(productlist[i].pdetails.product_id);
                if (idx >= 0) {
                  eans.splice(idx, 1);
                  ids.splice(idx, 1);
                }
              }
            }
          }
          if (eans.length > 0) {
            var plist = [];
            for (var i=0;i<eans.length;i++) {
              if (eans[i] == '') continue;
              plist.push(
                new Promise((resolve, reject) => {
                  Vue.http.get(utils.getServerPath()+'/product/search.is?product_name='+eans[i]).then(response => {
                    if (response.body.productlist != null) {
                      resolve(response.body.productlist[0]);
                    } else {
                      resolve(null);
                    }
                  }).catch (err => {
                    resolve(null);
                  });
                })
              );
            }
            Promise.all(plist).then(list => {
              if (list != null) {
                for (var i=0;i<list.length;i++) {
                  if (list[i] != null) {
                    self.processBulk(list[i], eqtys, 'product_code');
                  }
                }
              }
              //$('#myModal').modal('hide');
              this.$root.$emit('modal.bulkbox', {'mode':'hide'});
              if (self.alertlist.nostock.length > 0 || self.alertlist.ltstock.length > 0 || self.alertlist.adstock.length > 0) {
                $('#myModal01').modal('show');
              }
            }).catch(err => {
            });
          } else {
            //$('#myModal').modal('hide');
            this.$root.$emit('modal.bulkbox', {'mode':'hide'});
            if (self.alertlist.nostock.length > 0 || self.alertlist.ltstock.length > 0 || self.alertlist.adstock.length > 0) {
              $('#myModal01').modal('show');
            }
          }
        });
      }
    },
    initProducts:function() {
      this.$root.$emit('initproduct', 1);
    },
    tosort:function(n) {
      this.sort = n;
      this.searchable = true;
      this.search();
    },
    toggleFilter:function(n) {
      var found = false;
      this.searchable = true;
      for (var i=0;i<this.filters.length;i++) {
        if (this.filters[i] == n) {
          this.filters.splice(i, 1);
          found = true;
          break;
        }
      }
      if (!found) {
        this.filters.push(n);
      }
      this.search();
    },
    isFilter:function(n) {
      for (var i=0;i<this.filters.length;i++) {
        if (this.filters[i] == n) return true;
      }
      return false;
    },
    selectBrand:function(b) {
      this.brand = b;
      this.showBrand = false;
      this.searchable = true;
      this.search();
    },
    selectCat:function(b) {
      this.cat = b;
      this.showCat = false;
      this.searchable = true;
      this.search();
    },
    searchID:function(sid) {
//console.log(this.product_id, sid, (this.product_id == sid));
      //if ((this.product_id) && sid == this.product_id) return;
      this.product_name = null;
      this.brand = null;
      this.cat = null;
      this.search();
    },
    search:function(p, start, limit) {
      if (start == null && !this.searchable) return;
      this.searchable = false;
//console.log('search', this.product_name, this.product_id, p, start, limit);
      //if (this.product_name && p && this.product_name == p && !start && !limit ) return;
      var self = this;
      if (self.searching) return;
      self.searching = true;
      if (p != null) {
        if (p.indexOf('n') == 0 && !isNaN(parseInt(p.substring(1)))) {
          this.product_id = p.substring(1);
        } else {
          this.product_name = p;
        }
      }
      this.showSidebar = false;
      var reset = (start == null || start == 0);
      var url = 'search.is?product_name='+this.product_name;
      if (this.product_name != null && this.product_name != '') {
        if (reset) {
          window.location.href = '#'+this.product_name;
        }
        url = 'search.is?product_name='+this.product_name;
        this.product_id = null;
      } else if (this.product_id != null && this.product_id != '') {
        if (reset) {
          window.location.href = '#n'+this.product_id;
        }
        url = 'search.is?product_id='+this.product_id;
      } else if (this.product_id == null || this.product_id == '') {
        if (reset) {
          window.location.href = '#';
        }
        url = 'search.is?product_name=';
      }
      if (this.brand != null) {
        url = url + "&bc_cat_id="+this.brand.cat_id;
      }
      if (this.isFilter('sales')) {
        url = url + "&enable_dis=1";
      }
      if (this.isFilter('new')) {
        url = url + "&enable_new=1";
      }
      if (this.isFilter('best')) {
        url = url + "&enable_hot=1";
      }
      if (this.cat != null) {
        url = url + "&pc_cat_id="+this.cat.cat_id;
      }
      if (start != null) {
        url = url + "&start="+start;
      }
      if (limit != null) {
        url = url + "&limit="+limit;
      }
      this.$root.$emit('afterSearch', window.location.hash.substring(1));
      this.goPage(url, reset);
    },
    goPageNo:function(idx) {
      if (idx < 0) return;
      if (idx >= this.pagination.pages.length) return;
      this.goPage(this.pagination.pages[idx].url);
    },
    goPage:function(url, reset) {
      var self = this;
      if (this.sort != null) {
        if (this.sort == 'new') {
          url = url + '&order=p.create_date desc';
        } else if (this.sort == 'gp') {
          url = url + '&gp=1';
        } else if (this.sort == 'gps') {
          url = url + '&gps=1';
        }
      }
      self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
      Vue.http.get(utils.getServerPath()+'/product/'+url).then(response => {
        self.brands = response.body.brand_list;
        self.cats = response.body.cat_list;
        if (response.body.productlist != null && this.pdiscounts != null && this.pdiscounts.length > 0) {
          for (var i=0;i<response.body.productlist.length;i++) {
            for (var j=0;j<this.pdiscounts.length;j++) {
              if (this.pdiscounts[j].pids == null) {
                this.pdiscounts[j].pids = JSON.parse(this.pdiscounts[j].conditions);
              }
              if ((this.pdiscounts[j].pids.intype.type == 'product_id' && this.pdiscounts[j].pids.intype.typeval.indexOf(response.body.productlist[i].pdetails.product_id)) >= 0) {
                if (response.body.productlist[i].pdiscount == null) {
                  response.body.productlist[i].pdiscount = 0;
                }
                response.body.productlist[i].pdiscount = response.body.productlist[i].pdiscount + parseFloat(this.pdiscounts[j].dprice);
                //console.log('pdiscount found:', this.pdiscounts[j], response.body.productlist[i].pdiscount);
              }
            }
          }
        }
        if (reset) {
          self.allLoaded = false;
          self.products = response.body.productlist;
        } else if (self.pagination == null) {
          //self.products.push(response.body.productlist[0]);
          //Array.prototype.push.apply(self.products, response.body.productlist);
          for (var i=0;i<response.body.productlist.length;i++) {
            self.products.push(response.body.productlist[i]);
          }
        } else {
          self.products = response.body.productlist;
        }
        var c_curr = utils.getStorageStr("currency");
        if (c_curr == null) c_curr = '';
        if (response.body.productlist[0] != null && c_curr != response.body.productlist[0].curr) {
          if (utils.getCartStorage().length > 0) {
            //this.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.curr_changed, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
            setTimeout(function() {
              self.$root.$emit('remove', {'all':true});
            }, 1000);
          }
          utils.saveStorageStr("currency", response.body.productlist[0].curr);
        } else {
          self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
        }
        if (response.body.productlist.length == 0) {
          self.allLoaded = true;
        }
        //if (self.products.length > 1) {
        //  console.log('add history to last product');
        //  self.products[self.products.length-1].history = {};
        //}
        //self.initProducts();
        if (response.body.pagination != null) {
          self.pagination = response.body.pagination;
          self.pageno = parseInt(self.pagination.current_page / self.pagination.num);
        } else {
          self.pagination = null;
        }
        setTimeout(function() {
          self.searchCount++;
          self.$forceUpdate();
        }, 100);
        self.searching = false;
      }, response => {
        console.log('err', response);
        self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
        self.searching = false;
      });
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    removeErr: function(evt, name) {
      console.log(name);
      delete this.error[name];
      this.$forceUpdate();
    }
  },
  computed: {
    isProductList:function() {
      if (this.shelf_mode == undefined || this.shelf_mode == null) return true;
      if (parseInt(this.shelf_mode) == 0) return true;
      if (this.shelf_mode.substring(1, 2) == '1') return true;
      return false;
    },
    isPog:function() {
      if (this.shelf_mode == undefined || this.shelf_mode == null) return false;
      if (this.shelf_mode.substring(0, 1) == '1') return true;
      return false;
    }
  },
  mounted: function() {
    var self = this;
    if (window.location.href.indexOf('/product/') > 0) {
      Vue.cookie.set('pmode', 'list');
      if (!self.isProductList) {
        window.location.href = '../pog/index.html'
        return;
      }
    } else {
      return;
    }
    if (window.location.hash != null && window.location.hash.length > 1) {
//console.log(window.location.hash.substring(1), decodeURIComponent(window.location.hash.substring(1)));
      this.search(decodeURIComponent(window.location.hash.substring(1)));
    } else {
      this.search('');
    }
    this.$root.$on('scroll', data => {
      if (self.product_id) return;
      if (data == 'bottom') {
        if (self.allLoaded) return;
        if (self.pagination == null) {
          self.search(null, self.products.length,null);
        }
      }
    });
    this.$root.$on('search', data => {
      if (data) {
        this.searchable = true;
        this.search(data);
      } else {
        this.searchable = true;
        this.search('');
      }
    });
    this.$forceUpdate();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue